<div class="div-arriere-plan-action" (click)="clicAction($event)"></div>
<div [ngClass]="isMobile ? 'div-global-action-mob' : ''" class="div-global-action flex-col"
  (click)="clicAction($event)">
  <div id="center-square" class="w-full">
    <div>
      <p class="text-xxl bold dark-blue text-center">Bulletin enregistré <i class="pi pi-check"
          style="color: #17D425; font-size: 24px; font-weight: 900; stroke: #17D425; stroke-width: 4px;"></i></p>
      <p class="text-lg dark-blue no-margin text-center">
        Votre bulletin pour l'élection <span class="bold">{{title}}</span> est pris en compte, voici le chiffré
        de votre bulletin :

      </p>
    </div>
    <p class="text-center dark-blue bold" style="line-break: anywhere;">{{hash}}</p>

    <p class="dark-blue text-md no-margin text-center">
      (Vous pouvez le conserver en tant que preuve de vote, il vient également de vous être envoyé par e-mail)
    </p>

    <div class="flex-col gap-10 w-full align-items-center">
      <button class="action-button min-button" (click)="confirmVote(true)"
        *ngIf="nextElectionTitle.length > 3">
        Passer à l'élection {{nextElectionTitle}}
      </button>
      <button class="cancel-button min-button" (click)="confirmVote(false)">Fermer</button>
    </div>

  </div>
</div>
